import styled from "styled-components";
import {amountShadowAnimation, JackpotToastCurrencyDefaultBox} from "./jackpot-toast-currency.default.box";

/* TODO: After the MrG rebranding the color #DDDCAA should come from theme */
export const JackpotToastCurrencyMrGreenBox = styled(JackpotToastCurrencyDefaultBox)`
    color: #DDDCAA;
    text-shadow: 0px 0px 5px #DDDCAA;
    animation: ${props => amountShadowAnimation("#DDDCAA")} 0.8s ease-in-out infinite alternate forwards;
    .decimals {
        font-size: 2.4rem;
        @media ${props => props.theme.mediaQuery.mAndBelow} {
            font-size: 2.1rem;
        }
    }
`;